

window.addEventListener("load", function () {
    $('#nth-ld-25-ld-socials .btn-dangkytruoc').on('click', function (e) {
        e.preventDefault();


        const mainSwiper = $('.main-swiper')[0].swiper;
        mainSwiper.slideTo(0);
    });

});
